<template>
  <el-dropdown
    split-button
    type="primary"
    size="mini"
    @click="onReviewFinish()"
    @command="handleCommand">
    审核完成
    <el-dropdown-menu slot="dropdown">
      <el-dropdown-item command="passedRemain">通过未审核题目</el-dropdown-item>
    </el-dropdown-menu>
  </el-dropdown>
</template>

<script>
import QuestionReview from '@views/question-review/question-review'
import ReviewBox from '@views/question-review/components/ReviewBox/index'
import orderReviewValidate from '@views/order-review/mixins/order-review-validate.mixin.js'

export default {
  components: {},
  mixins: [orderReviewValidate],
  props: {
    salary: [Number, String],
    needGatherMarketPhoto: Boolean,
  },
  data () {
    return {}
  },
  computed: {
    ...Vuex.mapState({
      orderDetail: state => state.orderReview.orderDetail,
      // sjf 调整
      sjfOrderDetail: state => state.orderReview.sjfOrderDetail,
    }),
  },
  watch: {},
  beforeCreate () {},
  created () {},
  mounted () {},
  methods: {
    /**
     * 审核完成确认框
     */
    reviewConfirm (result, notPassNumbers) {
      if (result) {
        let marketPhotos = this.needGatherMarketPhoto ? QuestionReview().getAnswerMarketPhotos() : []
        ReviewBox.orderConfirm((data) => {
          this.$emit('pass', data)
        }, this.salary, marketPhotos, this.orderDetail)
      } else {
        ReviewBox.orderBack({
          callback: (data) => {
            this.$emit('not-pass', data)
          },
          defaultProlongTime: this.orderDetail.endtime,
          message: `第${notPassNumbers.join('、')}题未通过审核，请按照题目中错误原因进行修改。`,
        })
      }
    },
    /**
     * 审核完成方法
     */
    onReviewFinish () {
      // 检查SJF订单验证
      if (!this.checkSJFOrderValid()) {
        return
      }

      this.executeAnswerValidation()
    },
    executeAnswerValidation () {
      this.validateAnswer().then(({notPassed}) => {
        setTimeout(() => {
          this.reviewConfirm(notPassed.length === 0, notPassed)
        }, 200)
      })
    },
    handleCommand (command) {
      this[command]()
    },
    passedRemain () {
      let validQuestions = QuestionReview().getValidQuestions()
      validQuestions.forEach(({id}) => {
        if (!QuestionReview().isReviewed(id)) {
          QuestionReview().reviewPassed(id)
        }
      })
      this.$message.success('已通过未审核题目')
    },
  },
}
</script>
<style lang="scss"
       scoped>
// 带作用域的CSS
// https://vue-loader.vuejs.org/zh-cn/features/scoped-css.html
</style>



// WEBPACK FOOTER //
// src/views/order-review/components/OrderReviewFinishButton.vue